<div [id]="id + '841859f3-b792-4005-b2e9-44721ea1e65f'" #totalSpace [title]="email" [class.d-inline-block]="lockText" [class.ellipsis]="lockText">
  <span [id]="id + 'e5343ddc-c3e8-49e0-a077-36f7b98861da'" #spanName>{{ name }}</span>
  <span [id]="id + '799ee8a4-81bd-41e5-9032-a5252dd679d2'" #at *ngIf="email">@</span>
  <span [id]="id + '72f9c32d-ae74-4e16-93c5-c5b4cebe21c0'" #spanDomain>{{ domain }}</span>
</div>
